export const ADMIN_GET_ALL_USER = "admin/get/all/user";
export const ADMIN_USER_PAGE_INCREMANT = "admin/user/incremant";
export const ADMIN_USER_PAGE_DECREMENT = "admin/user/decremant";
export const ADMIN_DELETE_USER = "admin/delete/user";
